module.exports = __webpack_public_path__ + "img/cattunnel42.2f1ec5de.jpg";